var map = {
	"./8.jpg": 12631,
	"./FLR.jpg": 50375,
	"./fish 3.jpg": 87998,
	"./flowers 01.jpg": 20390,
	"./flowers 1.jpg": 48222,
	"./flowers 2.jpg": 27817,
	"./flr 1.jpg": 11226,
	"./girl 2.jpg": 6539,
	"./girl 3.jpg": 27054,
	"./girl 4.jpg": 64117,
	"./girl with dora.jpg": 98605
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18641;